import { X } from 'lucide-react';
import { useSyncExternalStore } from 'react';
import { dismissToast, subscribeToasts, toasts } from '@/lib/toast';

export function Toaster() {
  const items = useSyncExternalStore(subscribeToasts, toasts);
  if (!items.length) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4" role="status" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className="pointer-events-auto flex max-w-md items-start gap-3 rounded-lg bg-ink px-4 py-3 text-sm text-canvas shadow-pop">
          <span className="flex-1">{t.text}</span>
          <button type="button" aria-label="Закрыть" onClick={() => dismissToast(t.id)} className="opacity-70 hover:opacity-100">
            <X className="size-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
